import React from 'react';

import { supportedBrowsers } from '../../utils/browserDetection';
import PageWithFooter from '../PageWithFooter/PageWithFooter';
import './UnsupportedBrowserPage.styl';
import { UserLanguage } from '../../types';

const availableLocales: UserLanguage[] = [
  UserLanguage.EN_US,
  UserLanguage.ZH_CN,
  UserLanguage.ZH_HK,
];

function getSystemLocale(): UserLanguage {
  const systemLocale =
    window.navigator && window.navigator.language
      ? window.navigator.language
      : window.__config__.locale;
  if (availableLocales.indexOf(systemLocale) !== -1) {
    return systemLocale;
  }
  if (systemLocale === 'zh-TW') {
    return UserLanguage.ZH_HK;
  }
  if (systemLocale.indexOf('zh') !== -1) {
    return UserLanguage.ZH_CN;
  }
  return UserLanguage.EN_US;
}

const i18n: { [k: string]: any } = {
  title1: {
    'en-US': 'Sorry, you are using an unsupported browser.',
    'zh-CN': '抱歉，我们暂不支持您正在使用的浏览器。',
    'zh-HK': '抱歉，我們暫不支持您正在使用的瀏覽器。',
  },
  title2: {
    'en-US':
      'Please switch to one of the browsers below for a better experience.',
    'zh-CN': '请使用以下浏览器，获得更好的体验。',
    'zh-HK': '請使用以下瀏覽器，獲得更好的體驗。',
  },
  CHROME: {
    'en-US': 'Chrome',
    'zh-CN': 'Chrome',
    'zh-HK': 'Chrome',
  },
  IE11: {
    'en-US': 'IE 11',
    'zh-CN': 'IE 11',
    'zh-HK': 'IE 11',
  },
  EDGE: {
    'en-US': 'Edge',
    'zh-CN': 'Edge',
    'zh-HK': 'Edge',
  },
  SAFARI: {
    'en-US': 'Safari',
    'zh-CN': 'Safari',
    'zh-HK': 'Safari',
  }
};

function UnsupportedBrowserPage() {
  const locale = getSystemLocale();
  return (
    <PageWithFooter className="mio-unsupported-browser">
      <div className="mio-unsupported-browser__inner">
        <h1>{i18n.title1[locale]}</h1>
        <h2>{i18n.title2[locale]}</h2>

        <div className="mio-unsupported-browser__list">
          {supportedBrowsers.map(
            browserKey =>
              browserKey in i18n && (
                <div key={browserKey} className="mio-unsupported-browser__item">
                  <img
                    src={`https://resources.miotech.com/shared/icons/browser/${browserKey}.svg`}
                    alt={i18n[browserKey][locale]}
                  />
                  {i18n[browserKey][locale]}
                </div>
              ),
          )}
        </div>
      </div>
    </PageWithFooter>
  );
}

export default UnsupportedBrowserPage;
